import { all, call, fork, put, takeEvery } from 'redux-saga/effects'

import {
  CREATE_SELLER_REPLACEMENT,
  UPDATE_SELLER_REPLACEMENT,
  SEARCH_SELLER_REPLACEMENTS,
  GET_ACTIVE_REPLACEMENT,
} from '../constants/ActionsTypes'

import {
  createSellerReplacement,
  updateSellerReplacement,
  searchSellerReplacements,
  getActiveReplacementForTelemarketer,
} from '../api/SellerReplacements'

import {
  createSellerReplacementSuccess,
  createSellerReplacementError,
  updateSellerReplacementSuccess,
  updateSellerReplacementError,
  searchSellerReplacementsSuccess,
  searchSellerReplacementsError,
  getActiveReplacementSuccess,
  getActiveReplacementError,
  searchSellerReplacements as searchSellerReplacementsAction,
} from '../actions/SellerReplacements'

import { showMessages } from '../actions'

function* createSellerReplacementRequest({ payload }) {
  try {
    const result = yield call(createSellerReplacement, payload)
    yield put(createSellerReplacementSuccess(result))
    yield put(
      showMessages({
        summary: 'Replacement created successfully',
        type: 'success',
      }),
    )
    // Reload the list
    yield put(
      searchSellerReplacementsAction({
        active: true,
        page: 1,
        pageSize: 10,
      }),
    )
  } catch (error) {
    yield put(createSellerReplacementError(error))
  }
}

function* updateSellerReplacementRequest({ payload }) {
  try {
    const result = yield call(updateSellerReplacement, payload)
    yield put(updateSellerReplacementSuccess(result))
    yield put(
      showMessages({
        summary: 'Replacement updated successfully',
        type: 'success',
      }),
    )
    // Reload the list
    yield put(
      searchSellerReplacementsAction({
        active: true,
        page: 1,
        pageSize: 10,
      }),
    )
  } catch (error) {
    yield put(updateSellerReplacementError(error))
  }
}

function* searchSellerReplacementsRequest({ payload }) {
  try {
    const response = yield call(searchSellerReplacements, payload)
    yield put(searchSellerReplacementsSuccess(response))
  } catch (error) {
    yield put(searchSellerReplacementsError(error))
  }
}

function* getActiveReplacementRequest({ payload }) {
  try {
    const result = yield call(getActiveReplacementForTelemarketer, payload)
    yield put(getActiveReplacementSuccess(result))
  } catch (error) {
    yield put(getActiveReplacementError(error))
  }
}

export function* createSellerReplacementSaga() {
  yield takeEvery(CREATE_SELLER_REPLACEMENT, createSellerReplacementRequest)
}

export function* updateSellerReplacementSaga() {
  yield takeEvery(UPDATE_SELLER_REPLACEMENT, updateSellerReplacementRequest)
}

export function* searchSellerReplacementsSaga() {
  yield takeEvery(SEARCH_SELLER_REPLACEMENTS, searchSellerReplacementsRequest)
}

export function* getActiveReplacementSaga() {
  yield takeEvery(GET_ACTIVE_REPLACEMENT, getActiveReplacementRequest)
}

export default function* rootSaga() {
  yield all([
    fork(createSellerReplacementSaga),
    fork(updateSellerReplacementSaga),
    fork(searchSellerReplacementsSaga),
    fork(getActiveReplacementSaga),
  ])
}
